"use client";

import { getEventDates } from "@/app/actions/products";
import { Logo } from "@/components/svgs";
import { Button } from "@/components/ui/button";
import { useQuery } from "@tanstack/react-query";
import dayjs from "dayjs";
import Link from "next/link";

const NextDate = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["next-date"],
    queryFn: () => getEventDates(),
  });
  const today = dayjs();
  const nextDate = data?.find((date) =>
    dayjs(date.productEvent?.datum).isAfter(today)
  );

  if (isLoading) return <div>Loading...</div>;

  // If there's no next date, provide fallback
  if (!nextDate) {
    return (
      <div className="hidden md:flex gap-4 items-center">
        <Logo className="w-10 h-10" />
        <div>
          <h2 className="px-4 pt-2">Nästa Provning</h2>
          <Button variant="linkGold" effect="hoverUnderlineGold">
            Ingen kommande provning
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="hidden md:flex gap-4 items-center">
      <Logo className="w-10 h-10" />
      <div>
        <h2 className="px-4 pt-2">Nästa Provning</h2>
        <Button variant="linkGold" effect="hoverUnderlineGold" asChild>
          <Link
            href={`/vara-provningar/${
              nextDate.productCategories?.nodes[0]?.slug || ""
            }`}
            className="underline"
          >
            {nextDate.title || "Se provning"}
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default NextDate;
